import {useState} from 'react'
import {BrowserRouter, Routes, Route} from 'react-router'
import {Splash, Questionnaire, LooksLoading, Looks, CustomLook} from 'pages'
import {GetStarted, Intro} from 'pages/AppSetup'
import {SelfieIntro, SelfieCamera, SelfiePreview} from 'pages/Selfie'
import {Level, Concerns, Colours, Occasion, Vibes, Weather, DailyMakeup} from 'pages/Questionnaire/pages'
import {RedirectTo} from 'RedirectTo'
import './App.css'
import {assetsBaseUrl} from 'config'
import * as answerOptions from 'pages/Questionnaire/answers'

const name = 'Jessie'

const canned115Looks = {
  51057: {name: 'Smokey Glam Look', productCount: 4, imgUrl: `${assetsBaseUrl}/studio-makeup-green-gold.jpg`},
  48990: {name: 'Icy Look', productCount: 3, imgUrl: `${assetsBaseUrl}/studio-makeup-lip-gloss-shoulder.jpg`},
  44984: {name: 'Mermaid Look', productCount: 3, imgUrl: `${assetsBaseUrl}/studio-makeup-red-lipstick-hand.jpg`},
}
const cannedMbpaLooks = {
  52977: {name: 'Bold Lip Glam', productCount: 4, imgUrl: `${assetsBaseUrl}/studio-makeup-green-gold.jpg`},
  52971: {name: 'Smokey Full Glam', productCount: 3, imgUrl: `${assetsBaseUrl}/studio-makeup-lip-gloss-shoulder.jpg`},
  52963: {name: 'Boyfriend Blush', productCount: 3, imgUrl: `${assetsBaseUrl}/studio-makeup-red-lipstick-hand.jpg`},
}
const useCannedLooks = true
const cannedLooks = useCannedLooks ? cannedMbpaLooks : {}
const cannedPhotoId = 52977
const cannedPhotoUrl = cannedLooks?.[cannedPhotoId]?.imgUrl

const cannedAnswers = {
  level: [answerOptions.levels.beginner],
  concerns: [answerOptions.skinConcerns.dry, answerOptions.skinConcerns.oily],
  colours: [answerOptions.colours[0]],
  occasion: [answerOptions.occasions.wedding],
  vibes: [answerOptions.vibes.sexy],
  daily: [answerOptions.dailyMakeup.basic],
}

export const App = () => {
  const [selfieData, setSelfieData] = useState(cannedPhotoUrl)
  const [answers, setAnswers] = useState(cannedAnswers)
  const [looksData, setLooksData] = useState(cannedLooks)
  const [faceScanResults, setFaceScanResults] = useState()
  const [recommendedProducts, setRecommendedProducts] = useState()
  const [selectedLook, setSelectedLook] = useState()

  const chooseCannedPhoto = () => { setSelfieData(cannedPhotoUrl) }

  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Splash />}/>
        <Route path="splash" element={<Splash />}/>
        <Route path="app-setup" element={<RedirectTo path="/app-setup/get-started" />}/>
        <Route path="app-setup/get-started" element={<GetStarted />}/>
        <Route path="app-setup/intro" element={<Intro />}/>
        <Route path="consult" element={<RedirectTo path="/consult/selfie" />}/>
        <Route path="consult/selfie" element={<RedirectTo path="/consult/selfie/intro" />}/>
        <Route path="consult/selfie/intro" element={<SelfieIntro {...{chooseCannedPhoto}} />}/>
        <Route path="consult/selfie/camera" element={<SelfieCamera {...{setSelfieData}} />}/>
        <Route path="consult/selfie/preview" element={<SelfiePreview {...{selfieData}} />}/>
        <Route path="consult/questionnaire" element={<Questionnaire {...{setAnswers}} />}>
          <Route path="level" element={<Level givenName={name} />}/>
          <Route path="concerns" element={<Concerns />}/>
          <Route path="colours" element={<Colours />}/>
          <Route path="occasion" element={<Occasion />}/>
          <Route path="vibes" element={<Vibes />}/>
          <Route path="weather" element={<Weather />}/>
          <Route path="daily" element={<DailyMakeup />}/>
        </Route>
        <Route path="consult/load-looks" element={<LooksLoading {...{selfieData, answers, setLooksData, setFaceScanResults, setRecommendedProducts}} />}/>
        <Route path="consult/looks" element={<Looks {...{looksData, selectedLook, setSelectedLook}} />}/>
        <Route path="consult/looks/custom" element={<CustomLook {...{selfieData, faceScanResults, recommendedProducts}} />}/>
      </Routes>
    </BrowserRouter>
  )
}
